import React from 'react';

const HowMuchCanISave = () => {
    return (
        <div className="panel panel-default infobox">
            <div className="panel-body">
                <h4 className="text-primary">How much can I save?</h4>
                <p>Find out how much it costs to run appliances and heat your home using different energy sources.</p>
                <i className="fa fa-angle-right icon-widget-gas" />
                <a 
                    href="http://www.fortisbc.com/Rebates/SavingEnergy/SavingEnergyAtHome/HomeEnergyCalculator/Pages/default.aspx"
                    className="link-widget box-link" target="_blank"> Go to home energy calculator</a>
            </div>
        </div>
    );
};

export default HowMuchCanISave;